import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function StopCampaignTagIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "13"}
      height={height || "15.354"}
      viewBox="0 0 13 15.354"
    >
      <path
        id="Hand"
        d="M3.516,16.354h3.9a3.013,3.013,0,0,0,2.628-1.538l3.373-5.269-.19-.145-.011-.009a1.523,1.523,0,0,0-2.134.151l-.973,1.1a.292.292,0,0,1-.309.079c-.111-.037-.279-.119-.279-.228L9.515,3.676a.869.869,0,0,0-.828-.951.826.826,0,0,0-.795.9c0,.765,0,1.6,0,2.389,0,1.792,0,2.588,0,2.738,0,.068-.156.134-.208.182a.288.288,0,0,1-.2.075h0a.288.288,0,0,1-.2-.074c-.052-.048-.162-.114-.162-.182,0-.151,0-.947,0-2.739,0-.773,0-1.585,0-2.335,0-.006,0-.012,0-.018s0-.029,0-.044V1.931A.862.862,0,0,0,6.286,1H6.258a.848.848,0,0,0-.83.926V8.752c0,.143-.225.262-.379.262s-.34-.119-.34-.262V2.906a.853.853,0,1,0-1.7,0V8.752c0,.143-.195.262-.349.262s-.456-.119-.456-.262V5.614a.872.872,0,0,0-.87-.918H1.309a.923.923,0,0,0-.889.956c-.005,2.125,0,4.371,0,7.724A3.06,3.06,0,0,0,3.516,16.354Zm0,0"
        transform="translate(-0.417 -1)"
        fill="#c41700"
      />
    </svg>
  );
}
